import React from 'react';
import { object } from 'prop-types';
import mixpanelAnalytics from './MixpanelAnalytics';

const generatePageViewTracking = (
  WrappedPage,
  { eventName = 'Page Viewed' }
) => {
  return class WrapperComponent extends React.Component {
    static propTypes = {
      location: object
    };

    componentDidMount() {
      mixpanelAnalytics.trackPageEntered(eventName, this.props.location);
      this._pageEnteredAt = new Date().getTime();
      this._unloadListener = window.addEventListener(
        'beforeunload',
        this.pageUnloaded
      );
    }

    componentWillUnmount() {
      const timeLeft = new Date().getTime();
      mixpanelAnalytics.trackPageLeft(
        eventName,
        this.props.location,
        timeLeft - this._pageEnteredAt
      );
      window.removeEventListener('beforeunload', this._unloadListener);
    }

    pageUnloaded = () => {
      const timeLeft = new Date().getTime();
      mixpanelAnalytics.trackPageLeftOnUnload(
        eventName,
        this.props.location,
        timeLeft - this._pageEnteredAt
      );
    };

    render() {
      return <WrappedPage {...this.props} />;
    }
  };
};

const withPageViewTracking = (options = {}) => WrappedPage =>
  generatePageViewTracking(WrappedPage, options);

export default withPageViewTracking;



// WEBPACK FOOTER //
// ./src/analytics/withPageViewTracking.js